
// src/helpers/window-focus.js

import React from 'react'

const WAKEUP_INTERVAL = 3 * 60 * 1000
const RESUME_INTERVAL = 3 * 60 * 1000

export default function(Component) {
  class WindowFocusComponent extends React.Component {
    lastTime = (new Date()).getTime()
    lastFocus = (new Date()).getTime()

    timer = setInterval(()=> {
      var currentTime = (new Date()).getTime()
      if (currentTime > this.lastTime + WAKEUP_INTERVAL * 1.5) {
        // 本来ならcurrentTimeとlastTimeとの差はWAKEUP_INTERVAL秒以内になるはず、
        // PCがスリープして復帰するとWAKEUP_INTERVAL秒よりも時間が長くになることを検出する
        this.props.onWindowFocus && setTimeout(()=> this.props.onWindowFocus(this.props), 5000)
      }
      this.lastTime = currentTime
    }, WAKEUP_INTERVAL)

    onWindowFocus = ()=> {
      var currentTime = (new Date()).getTime()
      if (currentTime - this.lastFocus > RESUME_INTERVAL)
        this.props.onWindowFocus && setTimeout(()=> this.props.onWindowFocus(this.props), 5000)
    }

    onWindowBlur = ()=> {
      this.lastFocus = (new Date()).getTime()
    }

    componentDidMount() {
      window.addEventListener('focus', this.onWindowFocus)
      window.addEventListener('blur', this.onWindowBlur)
    }

    componentWillUnmount() {
      this.timer && clearInterval(this.timer)
      window.removeEventListener('focus', this.onWindowFocus)
      window.removeEventListener('blur', this.onWindowBlur)
    }

    render() {
      return <Component {...this.props} />
    }
  }

  WindowFocusComponent.displayName = `WindowFocus(${Component.displayName})`
  return WindowFocusComponent
}



// WEBPACK FOOTER //
// ./src/helpers/window-focus.js